import 'stream-chat-react/dist/css/v2/index.css';
import {
  AttachmentSelector,
  Channel,
  TextareaComposer,
  useChatContext,
  Window,
} from 'stream-chat-react';
import { ChatHeader } from './channel/chat-header/chat-header';
import ChannelInner from './channel/channel-inner';
import './custom-styles.css';
import { AudioAndVideoEnabledGuard } from './audio-and-video-enabled-guard';
import { EmojiPicker } from 'stream-chat-react/emojis';
import { ErrorBanner } from '../error-banner/error-banner';
import { LoaderCircle } from 'lucide-react';
import { SquaredBackground } from '../squared-background';
import { CustomAvatar } from './channel/custom-avatars/custom-avatar';
import { CustomMessage } from './channel/custom-message';
import { CustomQuotedMessage } from './channel/custom-quoted-message';
import { customReactionOptions } from './channel/custom-reactions/custom-reaction-options';
import { CustomReactionList } from './channel/custom-reactions/custom-reaction-list';
import { TypingIndicator } from './channel/typing-indicator/typing-indicator';
import { CustomReactionSelector } from './channel/custom-reactions/custom-reaction-selector';
import SendButton from './channel/send-button';
import { IncomingVideocallBanner } from '../video-call/incoming-video-call/incoming-videocall-banner';
import { CustomAttachments } from './channel/custom-attachments/custom-attachments';
import { CustomAttachmentPreviewList } from './channel/custom-attachments/previews/custom-attachment-preview-list';
import { CustomQuotedMessagePreview } from './channel/custom-quoted-message-preview/custom-quoted-message-preview';
import { CustomMessageTimestamp } from '../message-timestamp';
import { CustomDateSeparator } from './date-separator';

export const AuthenticatedChat = () => {
  const { channel } = useChatContext();

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className="h-screen w-full relative flex">
        <Channel
          reactionOptions={customReactionOptions}
          channel={channel}
          EmojiPicker={EmojiPicker}
          ReactionsList={CustomReactionList}
          // @ts-expect-error stream messed up the meta-types here
          ReactionSelector={CustomReactionSelector}
          maxNumberOfFiles={10}
          multipleUploads={true}
          SendButton={SendButton}
          TypingIndicator={TypingIndicator}
          EmptyStateIndicator={() => <></>}
          TextareaComposer={(props) => <TextareaComposer {...props} maxRows={20} />}
          MessageStatus={() => <></>}
          enrichURLForPreview
          LoadingIndicator={() => (
            <div className="min-h-screen flex flex-col justify-center items-center pl-2 space-x-2 relative isolate bg-background">
              <SquaredBackground />
              <div className="w-16 h-16 text-tertiary">
                <LoaderCircle className="w-16 h-16 animate-spin" />
              </div>
            </div>
          )}
          channelQueryOptions={{
            watch: true,
          }}
          Avatar={CustomAvatar}
          Attachment={CustomAttachments}
          AttachmentPreviewList={CustomAttachmentPreviewList}
          AttachmentSelector={(props) => (
            <AttachmentSelector
              {...props}
              attachmentSelectorActionSet={[
                {
                  type: 'uploadFile',
                  ActionButton: () => <div>Upload File</div>,
                  ModalContent: () => <div>Upload File</div>,
                },
              ]}
            />
          )}
          activeUnreadHandler={() => {
            // do nothing: the default implementation is showing "(1) (1) Document Title" in the browser tab, in case there's 2 unread messages
            // maybe we can customize this later if we need to
          }}
          Message={CustomMessage}
          QuotedMessage={CustomQuotedMessage}
          QuotedMessagePreview={CustomQuotedMessagePreview}
          MessageTimestamp={CustomMessageTimestamp}
          DateSeparator={CustomDateSeparator}
        >
          <Window>
            <div className="sticky top-0 z-10">
              <ErrorBanner />
              <IncomingVideocallBanner />
              <AudioAndVideoEnabledGuard />
              <ChatHeader />
            </div>
            <ChannelInner />
          </Window>
        </Channel>
      </div>
    </div>
  );
};
